<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-md-12 mb-5">
        <div>
          <step-progress
            :steps="mySteps"
            :current-step="currentStep"
            icon-class="fa fa-check"
            active-color="#c698fa"
          ></step-progress>
        </div>
      </div>
      <div class="col-md-12 mb-3">
        <b-button
          variant="secondary"
          @click="prevClick"
          class="mr-3"
        ><i
            class="fas fa-chevron-left text-grey"
            aria-hidden="true"
          ></i></b-button>
      </div>
      <div class="col-md-12 ">
        <h4>
          Package: {{ getPackageTypeFull(packageType) }}
          {{ getPackageDurationFull(packageDuration) }}
        </h4>
        <h4>Member: {{ memberName }}</h4>
        <hr class="mt-4" />
      </div>

      <div class="col-md-12">
        <form
          class="form-horizontal"
          role="form"
        >

          <div class="col-md-12">
            <label
              for="paidby"
              class="mr-4 control-label"
            >Paid By</label>
            <div
              class="form-check form-check-inline"
              v-if="payment.paidby != 'SUB'"
            >
              <input
                class="form-check-input"
                type="radio"
                name="paidby"
                id="paidby_cash"
                value="CASH"
                v-model="payment.paidby"
                :v="$v.payment.paidby"
              />
              <label
                class="form-check-label"
                for="paidby_cash"
              >Cash</label>
            </div>
            <div
              class="form-check form-check-inline"
              v-if="payment.paidby != 'SUB'"
            >
              <input
                class="form-check-input"
                type="radio"
                name="paidby"
                id="paidby_bank"
                value="BANK"
                v-model="payment.paidby"
                :v="$v.payment.paidby"
              />
              <label
                class="form-check-label"
                for="paidby_bank"
              >Bank Transfer</label>
            </div>
            <div
              class="form-check form-check-inline"
              v-if="payment.paidby != 'SUB'"
            >
              <input
                class="form-check-input"
                type="radio"
                name="paidby"
                id="paidby_card"
                value="CARD"
                v-model="payment.paidby"
                :v="$v.payment.paidby"
              />
              <label
                class="form-check-label"
                for="paidby_card"
              >Credit Card</label>
            </div>
            <div
              class="form-check form-check-inline"
              v-if="payment.paidby != 'SUB'"
            >
              <input
                class="form-check-input"
                type="radio"
                name="paidby"
                id="paidby_free"
                value="FREE"
                v-model="payment.paidby"
                @click="setPaymentFree"
                :v="$v.payment.paidby"
              />
              <label
                class="form-check-label"
                for="paidby_free"
              >FREE</label>
            </div>
            <div
              class="form-check form-check-inline"
              v-if="payment.paidby == 'SUB'"
            >
              <input
                class="form-check-input"
                type="radio"
                name="paidby"
                id="paidby_sub"
                value="SUB"
                v-model="payment.paidby"
                :v="$v.payment.paidby"
              />
              <label
                class="form-check-label"
                for="paidby_sub"
              >Subscription</label>
            </div>
          </div>
          <hr />

          <div class="col-md-12">
            <label
              for="memtype"
              class="mr-4 control-label"
            >Customer Type</label>
            <div
              class="form-check form-check-inline"
            >
              <input
                class="form-check-input"
                type="radio"
                name="memtype"
                id="memtype_student"
                value="STUDENT"                
                v-model="payment.memtype"
                @click="setMemtype('STUDENT')"
                :v="$v.payment.memtype"
                :disabled="!editCustomerType"
              />
              <label
                class="form-check-label"
                for="memtype_student"
              >Student</label>
            </div>
            <div
              class="form-check form-check-inline"
            >
              <input
                class="form-check-input"
                type="radio"
                name="memtype"
                id="memtype_staff"
                value="STAFF"
                v-model="payment.memtype"
                @click="setMemtype('STAFF')"
                :v="$v.payment.memtype"
                :disabled="!editCustomerType"
              />
              <label
                class="form-check-label"
                for="memtype_staff"
              >Staff</label>
            </div>
            <div
              class="form-check form-check-inline"
            >
              <input
                class="form-check-input"
                type="radio"
                name="memtype"
                id="memtype_public"
                value="PUBLIC"
                v-model="payment.memtype"
                @click="setMemtype('PUBLIC')"
                :v="$v.payment.memtype"
                :disabled="!editCustomerType"
              />
              <label
                class="form-check-label"
                for="memtype_public"
              >Public</label>
            </div>
            <div
              class="form-check form-check-inline"
            >
            <a
                    href="#"
                    @click.prevent="editCustomerType = 1"
                  >Edit</a>
            </div>
          </div>
          <hr />

          <div class="row">
            <div class="col-md-6">
              <div class="form-group form-inline mt-3">
                <label
                  for="qty"
                  class="col-sm-3 control-label"
                >Price</label>
                <div class="">
                  <input
                    type="text"
                    id="price"
                    name="price"
                    placeholder="Price"
                    class="form-control"
                    v-model="payment.price"
                    :disabled="!editPrice"
                  />
                  <a
                    href="#"
                    @click.prevent="editPrice = 1"
                    class="ml-2"
                  >Edit</a>
                </div>
              </div>

              <div class="form-group form-inline">
                <label
                  for="qty"
                  class="col-sm-3 control-label"
                >Quantity</label>
                <div class="">
                  <input
                    type="text"
                    id="qty"
                    name="qty"
                    placeholder="Quantity"
                    class="form-control"
                    v-model="payment.qty"
                    :disabled="!editQty"
                  />
                  <a
                    href="#"
                    @click.prevent="editQty = 1"
                    class="ml-2"
                  >Edit</a>
                </div>
              </div>

              <div class="form-group form-inline">
                <label
                  for="discount"
                  class="col-sm-3 control-label"
                >Discount</label>
                <div class="">
                  <input
                    type="text"
                    id="discount"
                    name="discount"
                    placeholder="Discount"
                    class="form-control"
                    v-model="payment.discount"
                  />
                  <select
                    class="form-control ml-2"
                    name="discount_unit"
                    v-model="payment.discount_unit"
                  >
                    <option value="percent">Percent</option>
                    <option value="amount">Amount</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group form-inline mt-3">
                <label
                  for="price"
                  class="col-sm-3 control-label"
                >Session</label>
                <div class="">
                  <input
                    type="text"
                    id="session"
                    name="session"
                    placeholder="Sessions"
                    class="form-control"
                    v-model="payment.session"
                    :disabled="!editSession"
                  />
                  <a
                    href="#"
                    @click.prevent="editSession = 1"
                    class="ml-2"
                  >Edit</a>
                </div>
              </div>
              <div class="form-group form-inline">
                <label
                  for="duration"
                  class="col-sm-3 control-label"
                >Duration</label>
                <div class="">
                  <input
                    type="text"
                    id="duration"
                    name="duration"
                    placeholder="Duration"
                    class="form-control"
                    v-model="payment.duration"
                    :disabled="!editDuration"
                  />
                  Days
                  <a
                    href="#"
                    @click.prevent="editDuration = 1"
                    class="ml-2"
                  >Edit</a>
                  <!--
                  <select
                    class="form-control ml-2"
                    name="duration_unit"
                    v-model="payment.duration_unit"
                    disabled
                  >
                    <option value="d">Day</option>
                    <option value="m">Month</option>
                  </select>
                  -->
                </div>
              </div>
              <div class="form-group form-inline">
                <label
                  for="activate_date"
                  class="col-sm-3 control-label"
                >Activate On</label>
                <div class="">
                  <date-picker
                    v-model="payment.activate_date"
                    valueType="format"
                  ></date-picker>
                </div>
              </div>
              <div
                class="form-group form-inline saledatediv p-3"
                v-if="isAuthLv2"
              >
                <label
                  for="sale_date"
                  class="col-sm-3 control-label"
                >Sale On</label>
                <div class="">
                  <date-picker
                    v-model="payment.sale_date"
                    valueType="format"
                  ></date-picker>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group form-inline mt-3">
                <label
                  for="note"
                  class="col-sm-3 control-label"
                >Note</label>
                <div class="">
                  <textarea
                    name="note"
                    rows="2"
                    cols="40"
                    placeholder="Add note here.."
                    class="form-control"
                    v-model="payment.note"
                  >
                  </textarea>
                </div>
              </div>
            </div>

            <!--
            <div class="col-md-6">
              <div class="form-group form-inline mt-4">
                <label
                  for="discount"
                  class="col-sm-3 control-label"
                >Staff</label>
                <div class="">
                  <select
                    class="form-control ml-2"
                    name="discount_unit"
                    v-model="employee_id"
                  >
                    <option value="7">Joe</option>
                    <option value="6">Amp</option>
                    <option value="5">Nok</option>
                    <option value="1">Chor</option>
                    <option value="8">Timm</option>
                    <option value="9">Minnie</option>
                    <option value="4">Arm</option>
                    <option value="3">Fluke</option>
                    <option value="2">Panas</option>
                  </select>
                </div>
              </div>
            </div>
-->
          </div>
          <div v-if="packageDuration == '5D' || packageDuration == '10D'|| packageDuration == '20D'" >
          <hr />
          <h4>QR Code Information</h4>
          <div class="mt-4"></div>
          <div class="row">
            <div class="col-md-6">
              
              <div class="form-group form-inline">
                <label
                  for="qr_phone"
                  class="col-sm-3 control-label"
                >Phone</label>
                <div class="">
                  <input
                    type="text"
                    id="qr_phone"
                    name="qr_phone"
                    placeholder="Phone Number"
                    class="form-control"
                    v-model="qrcode.member_phone"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group form-inline">
                <label
                  for="qr_email"
                  class="col-sm-3 control-label"
                >Email</label>
                <div class="">
                  <input
                    type="text"
                    id="qr_email"
                    name="qr_email"
                    placeholder="Email"
                    class="form-control"
                    v-model="qrcode.member_email"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

          <hr />
          <div class="row">
            <div class="col-md-12">
              <h4>Sub Total: {{ getSubTotalPrice }}</h4>
            </div>
            <div class="col-md-12">
              <h4>Discount: {{ getDiscount }}</h4>
            </div>
            <div class="col-md-12">
              <h4>Total: {{ getTotalPrice }}</h4>
            </div>
          </div>
        </form>
        <!-- /form -->
      </div>
    </div>
    <div class="mt-4 d-flex justify-content-center mb-5">
      <b-button
        size="lg"
        block
        variant="primary"
        @click.prevent="PaymentSubmit"
        :class="{ invalid: $v.$invalid }"
      >Next</b-button>
    </div>
  </div>
</template>
<script>
import {
  packageTypeFull,
  packageDurationFull
} from "./../js/utils/datamanip.js";
import { isAuthLv1, isAuthLv2 } from "./../js/utils/global.js";
import StepProgress from "vue-step-progress";
import "vue-step-progress/dist/main.css";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  between,
  maxLength,
  numeric
} from "vuelidate/lib/validators";
export default {
  mixins: [validationMixin],
  data() {
    return {
      mySteps: ["Package", "Member", "Payment", "Complete"],
      currentStep: 2,
      payment: {
        price: this.$store.getters.getSalePackage.price_public,
        qty: "1",
        session: this.$store.getters.getSalePackage.session_max,
        duration: this.$store.getters.getSalePackage.period,
        duration_unit: "d",
        activate_date: null,
        discount: 0,
        discount_unit: "percent",
        discount_final: 0,
        paidby:
          this.$store.getters.getSalePackage.duration == "6MSUB" ||
          this.$store.getters.getSalePackage.duration == "12MSUB"
            ? "SUB"
            : null,
        memtype:null,
        total: 0,
        note: null,
        sale_date: null
      },
      qrcode:{
        member_phone:null,
        member_email:null,
      },
      fsubtotal: 0,
      fdiscountfinal: 0,
      ftotal: 0,
      editPrice: false,
      editQty: false,
      editSession: false,
      editDuration: false,
      editCustomerType:false,
      paymentcache: null
    };
  },
  validations: {
    payment: {
      paidby: {
        required
      },
      memtype: {
        required
      },
    },
  },
  computed: {
    userRole() {
      return localStorage.getItem("user_role");
    },
    isAuthLv2,
    packageType() {
      return this.$store.getters.getSalePackage.type;
    },
    packageDuration() {
      return this.$store.getters.getSalePackage.duration;
    },
    memberName() {
      if (this.$store.getters.getSaleMember == null) {
        return "None - Walk In";
      }
      let membername =
        this.$store.getters.getSaleMember.firstname +
        " " +
        this.$store.getters.getSaleMember.lastname;
      return membername;
    },
    getSubTotalPrice() {
      this.fsubtotal = this.payment.price * this.payment.qty;
      return this.fsubtotal;
    },
    getDiscount() {
      if (this.payment.discount_unit == "percent") {
        this.fdiscountfinal = this.fsubtotal * (this.payment.discount / 100);
      } else if (this.payment.discount_unit == "amount") {
        this.fdiscountfinal = this.payment.discount;
      }
      this.payment.discount_final = this.fdiscountfinal;
      return this.fdiscountfinal;
    },

    getTotalPrice() {
      this.ftotal = this.fsubtotal - this.fdiscountfinal;
      this.payment.total = this.ftotal;
      return this.ftotal;
    }
  },
  methods: {
    setMemtype(memtype){
      //console.log(memtype);
      if(memtype=='STUDENT' && this.payment.paidby!='FREE'){
        this.payment.price = this.$store.getters.getSalePackage.price_student;
      }
      else if(memtype=='STAFF' && this.payment.paidby!='FREE'){
        this.payment.price = this.$store.getters.getSalePackage.price_staff;
      }
      else if(memtype=='PUBLIC' && this.payment.paidby!='FREE'){
        this.payment.price = this.$store.getters.getSalePackage.price_public;
      }
    },
    setPaymentFree() {
      //this.paymentcache = this.payment.price;
      this.payment.price = 0;
    },
    prevClick() {
      this.$store.dispatch("setSaleState", 1);
      //console.log(this.$store.getters.getSalePackage);
      /* sale_package: {
      id: null,
      type: null,
      duration: null,
      price: null,
      period: null,
      session_max: null,
    }, */
    },
    PaymentSubmit() {
      if (this.payment.paidby == null) {
        return false;
      }

      this.$store.dispatch("setSalePayment", this.payment);
      this.$store.dispatch("setSaleQrcode", this.qrcode);
      this.$store.dispatch("setSaleState", 3);
      //this.$store.dispatch("setSaleEmployee", this.employee_id);
      //console.log(this.payment);
    },
    getPackageTypeFull(key) {
      return packageTypeFull[key];
    },
    getPackageDurationFull(key) {
      return packageDurationFull[key];
    }
  },
  components: {
    "step-progress": StepProgress,
    DatePicker
  },
  mounted() {
    let date = new Date().toISOString().slice(0, 10);

    /*
    var d = new Date(date);
    date = [
    d.getFullYear(),
    ('0' + (d.getMonth() + 1)).slice(-2),
    ('0' + d.getDate()).slice(-2)
    ].join('-'); */

    this.payment.activate_date = date;
    if (this.$store.getters.getSaleMember != null) {
      this.payment.memtype = this.$store.getters.getSaleMember.type;
      if(this.payment.memtype=='STUDENT'){
        this.payment.price = this.$store.getters.getSalePackage.price_student;
      }
      else if(this.payment.memtype=='STAFF'){
        this.payment.price = this.$store.getters.getSalePackage.price_staff;
      }
      else if(this.payment.memtype=='PUBLIC'){
        this.payment.price = this.$store.getters.getSalePackage.price_public;
      }
    }
    else{
      this.editCustomerType = true;
      
    }
  }
};
</script>
<style scoped>
input[type="radio"] {
  transform: scale(1.5);
}
.saledatediv {
  background-color: orange;
}
</style>
